
type As = '%' | 'x'

// expects the pnl number provided via performance history external data, pnl is a percentage value, eg. 5.43 would mean 5.43%
export default function formatRoi(pnl: number, as: As = '%' ): string {

  const formatterFnsMap: Record<As, ((pnl: number) => string)> = {
    '%': pnl => {

      const sign = pnl < 0 ? '-' : '+'

      return `${sign}${pnl.toFixed(2)}%`

    },
    'x': pnl => `${(1 + pnl/100).toFixed(2)}x`
  }

  return formatterFnsMap[as](pnl)

}